export default theme => ({
  commonInput: {
    height: 56,
    borderRadius: 4,
    "& .Mui-error": {
      borderColor: "#C72323"
    }
  }
});
